import React from 'react';
import TopLanding from '../../shared/components/TopLanding';

function Blog() {
    return (
        <div>
            <TopLanding />
        </div>
    )
}

export default Blog;
